import { render, staticRenderFns } from "./FlatSelectorTextMultiple.component.vue?vue&type=template&id=226c521e&scoped=true&lang=pug"
import script from "./FlatSelectorTextMultiple.component.vue?vue&type=script&lang=ts"
export * from "./FlatSelectorTextMultiple.component.vue?vue&type=script&lang=ts"
import style0 from "./FlatSelectorTextMultiple.component.vue?vue&type=style&index=0&id=226c521e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226c521e",
  null
  
)

export default component.exports